// civil services
import Interior from "../Assets/Images/Services/civil-services/interior.png";
import BOQ from "../Assets/Images/Services/civil-services/boq.png";
import BiddingSolution from "../Assets/Images/Services/civil-services/bidding-solutions.png";

// solar services
import LoadAudits from "../Assets/Images/Services/solar-services/load-audits.png";
import SystemDesgin from "../Assets/Images/Services/solar-services/system-design.png";
import CostEstimation from "../Assets/Images/Services/solar-services/cost-estimation.png";
import ProcurementAssistance from "../Assets/Images/Services/solar-services/procurement-assistance.png";

// lighting services
import LightingDesign from "../Assets/Images/Services/lighting-services/1.png";
import MaterialPlanning from "../Assets/Images/Services/lighting-services/2.png";
import Product from "../Assets/Images/Services/lighting-services/3.png";

// analytics
import SAPAnalytics from "../Assets/Images/Services/analytics/1.png";
import TabularModels from "../Assets/Images/Services/analytics/2.png";
import SAPAnalyticsCloud from "../Assets/Images/Services/analytics/3.png";

// web development
import CMS from "../Assets/Images/Services/web-development/1.png";
import Website from "../Assets/Images/Services/web-development/2.png";
import AiAutomation from "../Assets/Images/Services/web-development/3.png";
import WebManagement from "../Assets/Images/Services/web-development/4.png";

// ai-solutions
import CSD from "../Assets/Images/Services/ai-solutions/1.png";
import AiWebsite from "../Assets/Images/Services/ai-solutions/2.png";
import Chatbot from "../Assets/Images/Services/ai-solutions/3.png";

//marketing 
import SMM from "../Assets/Images/Services/marketing/1.png";
import SEO from "../Assets/Images/Services/marketing/2.png";
import GoogleAds from "../Assets/Images/Services/marketing/3.png";

// hr-services
import HR from "../Assets/Images/Services/hr-services/1.png";
import Accounting from "../Assets/Images/Services/hr-services/2.png";
import ColdCalling from "../Assets/Images/Services/hr-services/3.png";
import EngineeringStaff from "../Assets/Images/Services/hr-services/4.png";

// business-operations
import Logistics from "../Assets/Images/Services/business-operations/1.png";
import Inventory from "../Assets/Images/Services/business-operations/2.png";
import eCommerce from "../Assets/Images/Services/business-operations/3.png";

export const serviceDetailsData = {
  // engineering solution
  "civil-services": {
    metaTitle: "Civil Services – Construction & Infrastructure Solutions",
    metaDescription:
      "Fusion Hub delivers expert civil services, providing solutions for infrastructure development, construction, and project management for businesses.",
    title: "Civil Services",
    description:
      "Ensure every phase of your construction or fit out project runs efficiently and economically with our expert civil services. We provide strategic project planning, cost control, and bid management that align with your deadlines, budgets, and compliance needs. From the earliest estimates to the final submission, we streamline documentation, minimize overruns, and enable confident, data backed decision making empowering you to execute complex projects with greater control and clarity.",
    services: [
      {
        title: "Interior Fit Out Cost Estimation",
        description:
          "Get precise cost projections for interior works, including labor, materials, and finishes. We help you budget effectively before you build.",
        bgImg: Interior,
      },
      {
        title: "BOQ (Bill of Quantities) / Material Takeoff",
        description:
          "We prepare detailed quantity surveys and material takeoffs that outline every component of your project essential for procurement and accurate costing.",
        bgImg: BOQ,
      },
      {
        title: "Tender Support & Bidding Solutions",
        description:
          "Win more projects with our tailored bidding documentation and strategic tender assistance, including scope review, pricing strategy, and proposal preparation.",
        bgImg: BiddingSolution,
      },
    ],
    whyChooseUs: {
      heading: "Why Choose Us for Civil Services",
      points: [
        "✔️ Accurate and transparent cost estimation based on real world pricing and project scope.",
        "✔️ Expertise in BOQ preparation that ensures procurement accuracy and resource planning.",
        "✔️ Proven success in supporting clients through competitive bidding processes.",
        "✔️ Emphasis on reducing budget overruns and improving project delivery timelines.",
        "✔️ End to end documentation and analysis that supports regulatory and client compliance.",
        "✔️ Flexible service options that adapt to projects of all sizes and complexities.",
      ],
    },
    icon: "🏗",
  },
  "solar-services": {
    metaTitle: "Solar Services – Sustainable Energy Solutions",
    metaDescription:
      "Switch to sustainable energy with Fusion Hub’s solar services. We offer expert solar solutions to power your business with eco-friendly technology.",
    title: "Solar Services",
    description:
      "Maximize your energy independence with expertly designed and efficiently estimated solar power systems. Our solar consulting covers every technical and commercial aspect load audits, system layout, bill of materials, and procurement ensuring that your investment is optimized for performance and cost. Whether you're powering a home, office, or industrial site, we help you plan smart, scale sustainably, and transition to clean energy with confidence.",
    services: [
      {
        title: "Load Audits",
        description:
          "We assess your current and future energy needs to size solar systems accurately and optimize energy consumption.",
        bgImg: LoadAudits,
      },
      {
        title: "System Design",
        description:
          "Our engineers design efficient solar power systems customized to your site's specifications, including panel layout, inverter selection, and cable sizing.",
        bgImg: SystemDesgin,
      },
      {
        title: "Cost Estimation & Material Takeoff",
        description:
          "Know exactly what your solar project will cost. We provide accurate estimates and a detailed list of materials for procurement.",
        bgImg: CostEstimation,
      },
      {
        title: "Procurement Assistance",
        description:
          "We help you source high quality components (panels, inverters, batteries, etc.) from trusted suppliers to ensure system reliability and performance.",
        bgImg: ProcurementAssistance,
      },
    ],
    whyChooseUs: {
      heading: "Why Choose Us for Solar Services",
      points: [
        "✔️ Holistic approach from energy audit to final procurement.",
        "✔️ Technical accuracy in system sizing, layout, and electrical design.",
        "✔️ Reliable cost estimation that helps avoid surprises and delays.",
        "✔️ Access to a trusted network of solar component suppliers.",
        "✔️ Sustainable planning that considers energy ROI and regulatory compliance.",
        "✔️ Ideal for residential, commercial, and off grid solar projects.",
      ],
    },
    icon: "☀️",
  },
  "lighting-services": {
    metaTitle: "Lighting Services – Efficient & Innovative Lighting Solutions",
    metaDescription:
      "Fusion Hub offers professional lighting services, delivering energy-efficient and creative lighting solutions tailored to your business needs.",
    title: "Lighting Services",
    description:
      "Bring form and function together with our specialized lighting services designed to optimize aesthetics, energy use, and budget. We guide your lighting strategy from concept through procurement ensuring every fixture supports your architectural intent, complies with standards, and maximizes impact. Whether for luxury homes, retail, offices, or industrial spaces, our consultancy ensures your lighting enhances both mood and performance.",
    services: [
      {
        title: "Lighting Design",
        description:
          "We create custom lighting layouts that balance function, ambiance, and energy efficiency, based on architectural plans and user needs.",
        bgImg: LightingDesign,
      },
      {
        title: "Cost Analysis & Material Planning",
        description:
          "Our cost analysis services ensure your lighting solutions fit your budget, while our material planning ensures nothing is missed in procurement.",
        bgImg: MaterialPlanning,
      },
      {
        title: "Product Sourcing & Procurement",
        description:
          "We recommend and procure high performance lighting products that align with your design, budget, and sustainability goals.",
        bgImg: Product,
      },
    ],
    whyChooseUs: {
      heading: "Why Choose Us for Lighting Services",
      points: [
        "✔️ Expertise in lighting design across commercial, residential, and industrial sectors.",
        "✔️ Clear focus on energy efficiency without compromising visual quality.",
        "✔️ Seamless coordination between design, costing, and procurement stages.",
        "✔️ Access to a wide catalog of global lighting products and suppliers.",
        "✔️ Value engineered solutions that align with your budget and goals.",
        "✔️ Responsive collaboration with architects, engineers, and end users.",
      ],
    },
    icon: "💡",
  },

  // Digital And It
  analytics: {
    metaTitle: "Analytics Services – Data-Driven Insights for Business Growth",
    metaDescription:
      "Fusion Hub offers expert analytics services to help your business make data-driven decisions, optimize operations, and achieve sustainable growth.",
    title: "Analytics & Business Intelligence",
    description:
      "In today's data driven world, success depends on how well you understand and act on your data. Our end to end analytics and business intelligence services are designed to give you that competitive edge. Whether you're working with massive enterprise datasets or just beginning your digital transformation journey, we help you transform raw data into meaningful insights. From automating performance reports and creating interactive dashboards to forecasting trends and optimizing KPIs, we bring clarity to complexity empowering you to make faster, smarter, and more confident business decisions.",
    services: [
      {
        title: "SAP Analytics",
        description:
          "Harness the full power of SAP’s data ecosystem. We help you integrate, analyze, and visualize large scale enterprise data in real time enabling automated reporting, KPI tracking, and better operational visibility. From SAP BW to S/4HANA and Fiori dashboards, we support your entire analytics journey.",
        bgImg: SAPAnalytics,
      },
      {
        title: "Power BI & Tabular Models",
        description:
          "Build dynamic dashboards and interactive reports tailored to your business goals. We specialize in Power BI development and tabular data modeling, allowing you to track performance, identify trends, and make data driven decisions with ease across all departments and functions.",
        bgImg: TabularModels,
      },
      {
        title: "SAP Analytics Cloud (SAC)",
        description:
          "Plan, forecast, and visualize business data all in one unified cloud platform. SAC combines analytics and planning into a single solution with collaborative tools, predictive analytics, and customizable dashboards that simplify strategic decision making across teams.",
        bgImg: SAPAnalyticsCloud,
      },
    ],
    icon: "📊",
    whyChooseUs: {
      heading: "Why Choose Us for Analytics & Business Intelligence",
      points: [
        "✔️ Deep expertise in SAP, Power BI, and modern analytics platforms tailored to enterprise and SME needs.",
        "✔️ Custom dashboards and data models aligned with your key business goals and performance indicators.",
        "✔️ Proven ability to handle complex, large scale datasets across industries including finance, retail, logistics, and tech.",
        "✔️ End to end services from data extraction and modeling to visualization, reporting, and predictive analysis.",
        "✔️ Agile delivery with ongoing support, optimization, and knowledge transfer to your internal teams.",
        "✔️ Transparent processes, data governance best practices, and secure handling of sensitive business information.",
      ],
    },
  },
  "web-development": {
    metaTitle: "Web Development Services – Custom Websites & Solutions",
    metaDescription:
      "Fusion Hub specializes in web development, creating custom websites and web applications that enhance user experience and drive business success.",
    title: "Web Development",
    description:
      "Your website is often the first impression your brand makes so we make sure it’s fast, functional, secure, and designed for impact. Whether you're a startup, SMB, or enterprise, our web development services are built to drive conversions, improve user experience, and support your long term digital strategy. From CMS platforms to fully custom builds and AI powered automations, we deliver websites that don't just look good they work hard for your business.",
    services: [
      {
        title: "CMS Platforms",
        description:
          "We develop user friendly websites using popular Content Management Systems (like WordPress, Shopify, or Webflow), giving you control and scalability.",
        bgImg: CMS,
        // icon
      },
      {
        title: "Custom & Basic Website Development",
        description:
          "Whether you need a simple site or a fully customized platform, we create responsive, secure, and SEO optimized websites tailored to your needs.",
        bgImg: Website,
      },
      {
        title: "AI Integrations & Automation",
        description:
          "Enhance user experience and efficiency with AI driven features such as dynamic content, intelligent search, and automated workflows.",
        bgImg: AiAutomation,
      },
      {
        title: "Full Website Management",
        description:
          "We take care of everything from hosting and updates to performance monitoring and security so you can focus on your business.",
        bgImg: WebManagement,
      },
    ],
    icon: "🌐",
    whyChooseUs: {
      heading: "Why Choose Us for Web Development",
      points: [
        "✔️ Expertise across leading CMS platforms (WordPress, Shopify, Webflow) and custom stacks.",
        "✔️ Pixel perfect responsive designs that look great and perform seamlessly across all devices.",
        "✔️ SEO optimized structure and fast loading speeds to enhance visibility and engagement.",
        "✔️ Integration of AI tools for smarter websites chatbots, search, personalization, and more.",
        "✔️ Full lifecycle management: design, development, testing, deployment, and ongoing support.",
        "✔️ Transparent communication, milestone based delivery, and scalable solutions built for growth.",
      ],
    },
  },
  "ai-solutions": {
    metaTitle: "AI Solutions – Advanced Artificial Intelligence for Business",
    metaDescription:
      "Transform your business with Fusion Hub's AI solutions. We provide innovative AI technologies that enhance automation, decision-making, and efficiency.",
    title: "AI Solutions",
    description:
      "Stay ahead of the curve by embedding intelligence into your digital ecosystem. Our AI Solutions are designed to streamline operations, personalize user experiences, and drive smarter decision making across your business. From custom built AI applications to smart website features and 24/7 chatbots, we help you automate repetitive tasks, understand user behavior, and deliver value at scale without compromising on performance or security.",
    services: [
      {
        title: "Custom Software Development",
        description:
          "Our developers build tailored AI powered applications that align with your business logic, data workflows, and customer needs.",
        bgImg: CSD,
      },
      {
        title: "AI Powered Website Features",
        description:
          "Add smart tools like product recommendations, behavior tracking, and real time support to elevate your digital experience.",
        bgImg: AiWebsite,
      },
      {
        title: "Chatbot Integration for eCommerce",
        description:
          "Boost conversions and customer satisfaction with intelligent chatbots that handle FAQs, product queries, and order tracking 24/7.",
        bgImg: Chatbot,
      },
    ],
    whyChooseUs: {
      heading: "Why Choose Us for AI Solutions",
      points: [
        "✔️ Deep expertise in AI technologies including NLP, machine learning, and predictive analytics.",
        "✔️ Custom software solutions that align perfectly with your business objectives and workflows.",
        "✔️ Seamless AI integration into websites, CRMs, eCommerce platforms, and internal systems.",
        "✔️ Focus on real world use cases boosting efficiency, engagement, and ROI.",
        "✔️ Scalable architectures designed to evolve as your AI needs grow.",
        "✔️ Ethical AI development with data privacy, transparency, and reliability at the core.",
      ],
    },
    icon: "🤖",
  },
  "app-&-software": {
    metaTitle: "Smart Software Solutions – Custom Tools for Business Growth",
    metaDescription:
      "Upgrade your business with Fusion Hub's powerful software solutions. We develop custom tools to automate tasks, improve efficiency, and support smarter decisions.",
    title: "App & Software Development",
    description:
      "We design and develop custom software and applications tailored to your business needs. From mobile apps to full-scale web platforms, our services cover UI/UX design, front- and back-end development, integration, testing, and ongoing support. Whether you're building a new solution or improving an existing one, we deliver reliable, scalable, and user-friendly software.",
    whyChooseUs: {
      heading: "Why Choose Us for Software Solutions",
      points: [
        "✔️ Proven track record delivering high-quality, scalable, and secure software across industries — from startups to enterprises.",
        "✔️ Intuitive, engaging user experiences built using UX/UI best practices and real user feedback.",
        "✔️ Agile development process ensuring transparency, faster delivery, and adaptability to evolving requirements.",
        "✔️ End-to-end software development — from idea validation and prototyping to deployment and post-launch support.",
        "✔️ Modern tech stacks and scalable architectures ready for AI, cloud-native, and cross-platform mobile development.",
        "✔️ Commitment to quality through rigorous testing, code reviews, and performance optimization.",
        "✔️ Long-term partnership approach — responsive, dependable, and invested in your success.",
      ],
    },
    icon: "💻",
  },
  marketing: {
    metaTitle: "Digital Marketing Services – Drive Traffic, Leads & Growth",
    metaDescription:
      "Grow your brand with Fusion Hub's digital marketing services. We help you reach the right audience, boost conversions, and build online presence.",
    title: "Digital Marketing",
    description:
      "We provide comprehensive marketing solutions designed to boost your brand visibility, attract your ideal audience, and drive measurable results. Our services include digital marketing strategy, social media management, content creation, paid advertising (Google & social), SEO, email campaigns, and performance analytics. Whether you're looking to grow your online presence or launch a targeted campaign, we tailor our approach to meet your unique business goals.",
    services: [
      {
        title: "Social Media Marketing",
        description:
          "We help businesses grow their online presence through strategic social media marketing. Our services include content creation, account management, audience engagement, paid ad campaigns, and performance tracking across platforms like Instagram, Facebook, LinkedIn, and more. We tailor each strategy to align with your brand goals and connect you with the right audience.",
        bgImg: SMM,
      },
      {
        title: "Search Engine Optimization (SEO)",
        description:
          "Our SEO services are designed to improve your website’s visibility on search engines, drive organic traffic, and boost your rankings. We offer on-page optimization, keyword research, technical SEO, link building, and content strategy tailored to your business goals. With a data-driven approach, we help you attract the right audience and grow sustainably online.",
        bgImg: SEO,
      },
      {
        title: "Google Ads/PPC",
        description:
          "We create and manage targeted Google Ads campaigns to drive qualified traffic and maximize your ROI. Our services include keyword research, ad creation, campaign setup, A/B testing, and ongoing optimization. Whether you're aiming for leads, sales, or brand visibility, we tailor your ads to reach the right audience at the right time.",
        bgImg: GoogleAds,
      },
    ],
    whyChooseUs: {
      heading: "Why Choose Us for Marketing",
      points: [
        "✔️ We don’t just create marketing campaigns — we craft measurable solutions that drive leads, sales, and growth. Every strategy we implement is backed by data, tested continuously, and optimized for performance.",
        "✔️ Our team brings deep experience across industries, from tech startups to established retail brands. We understand your market, your audience, and how to position your brand to stand out.",
        "✔️ From branding and content creation to paid ads, SEO, and social media — we do it all. You’ll get a cohesive, end-to-end marketing strategy that covers every touchpoint.",
        "✔️ We don’t believe in one-size-fits-all. Your business is unique, and your marketing should be too. We build strategies tailored specifically to your goals, budget, and audience.",
        "✔️ We’re partners, not vendors. You’ll always know what we’re doing, why we’re doing it, and how it’s performing — with regular reports and open lines of communication.",
        "✔️ Don’t take our word for it — our campaigns consistently outperform benchmarks and deliver real ROI. Our clients stay with us because we deliver.",
      ],
    },
    icon: "📈",
  },

  // dedicated resources services
  "hr-services": {
    metaTitle: "Dedicated Resources Services – Fusion Hub",
    metaDescription:
      "Get dedicated resources for your business needs. Fusion Hub offers scalable solutions in HR, business operations, and specialized expertise for your projects.",
    title: "HR Services",
    description:
      "We help you scale efficiently by providing skilled HR, finance, and administrative professionals who seamlessly integrate into your business operations. Whether you need help managing teams, handling accounts, or boosting lead generation, we deliver flexible and cost effective staffing that supports your core business functions without compromising on quality or control.",
    services: [
      {
        title: "HR Services",
        description:
          "We provide qualified professionals to support core business functions, allowing you to focus on growth and strategic priorities.",
        bgImg: HR,
      },
      {
        title: "Accounting & Finance",
        description:
          "Our skilled accounting professionals manage bookkeeping, invoicing, and financial reporting with precision and efficiency.",
        bgImg: Accounting,
      },
      {
        title: "Cold Calling & Lead Outreach",
        description:
          "Dedicated agents perform targeted outreach activities to generate qualified leads and boost your sales funnel.",
        bgImg: ColdCalling,
      },
      {
        title: "Engineering Support Staff",
        description:
          "Hire technical assistants and engineers for documentation, CAD drafting, estimation support, and related engineering tasks.",
        bgImg: EngineeringStaff,
      },
    ],
    whyChooseUs: {
      heading: "Why Choose Us for HR Services",
      points: [
        "✔️ Access to pre vetted professionals with relevant domain experience.",
        "✔️ Flexible hiring options full time, part time, or contract based.",
        "✔️ Seamless integration with your internal teams and workflows.",
        "✔️ Scalable staffing solutions to match your business growth.",
        "✔️ Comprehensive support across HR, finance, technical, and administrative roles.",
        "✔️ Focused on quality, compliance, and performance monitoring.",
      ],
    },
  },
  "business-operations": {
    metaTitle: "Business Operations Services – Optimize Your Business",
    metaDescription:
      "Fusion Hub offers expert business operations services, helping you optimize processes, reduce costs, and enhance productivity for long-term success.",
    title: "Business Operations Support",
    description:
      "Run your business with greater speed and flexibility by outsourcing essential back office functions. From logistics coordination to e-commerce management, our skilled professionals help streamline day to day operations so you can focus on scaling. We support both remote and hybrid models with reliable, hands on management and accountability.",
    services: [
      {
        title: "Logistics Coordination",
        description:
          "Our specialists help manage shipping, deliveries, vendor communication, and end to end logistics processes.",
        bgImg: Logistics,
      },
      {
        title: "Inventory Management",
        description:
          "Maintain accurate inventory records and smooth replenishment cycles with remote or hybrid inventory management services.",
        bgImg: Inventory,
      },
      {
        title: "E commerce Store Management",
        description:
          "Our teams assist with product uploads, order fulfillment, customer support, and backend management on platforms like Shopify, WooCommerce, and Amazon.",
        bgImg: eCommerce,
      },
    ],
    whyChooseUs: {
      heading: "Why Choose Us for Business Operations Support",
      points: [
        "✔️ Expertise in tools and platforms used across logistics, inventory, and e commerce.",
        "✔️ Dedicated resources who adapt to your operational style and needs.",
        "✔️ Proven ability to optimize and automate repetitive tasks for efficiency.",
        "✔️ Support across industries including retail, tech, logistics, and services.",
        "✔️ Fast onboarding and minimal training time required.",
        "✔️ Affordable, scalable solutions with transparent reporting and KPIs.",
      ],
    },
  },
  "financial-services": {
    metaTitle:
      "Financial Services – Smarter Tools for Managing Business Finances",
    metaDescription:
      "Simplify your business finances with Fusion Hub. We offer organized, reliable solutions for accounting, budgeting, and reporting.",
    title: "Financial Services",
    description:
      "We offer tailored financial solutions to help you manage, grow, and protect your assets. Our services include financial planning, budgeting, investment advice, tax optimization, and risk management. Whether you're an individual or a business, we provide expert guidance to support informed financial decisions and long-term stability.",
    whyChooseUs: {
      heading: "Why Choose Us for Financial Services",
      points: [
        "✔️ Expert financial management backed by decades of experience and industry knowledge.",
        "✔️ Tailored strategies to meet your unique personal, business, or investment goals.",
        "✔️ Transparent, ethical practices ensuring you always know where your finances stand.",
        "✔️ Comprehensive services from tax planning to retirement advice for complete financial well-being.",
        "✔️ Data-driven insights and modern tools to help you make confident, informed decisions.",
        "✔️ Proactive approach to help you plan ahead and stay ahead of economic changes.",
      ],
    },
    icon: "💰",
  },
  "administrative-services": {
    metaTitle: "Administrative Services – Streamline Your Business Operations",
    metaDescription:
      "Run your business smoothly with Fusion Hub’s reliable administrative support. We help you manage tasks, teams, and time efficiently.",
    title: "Administrative Services",
    description:
      "Focus on what matters while we handle the day-to-day operations. Our adWe design and develop custom software and applications tailored to your business needs. From mobile apps to full-scale web platforms, our services cover UI/UX design, front- and back-end development, integration, testing, and ongoing support. Whether you're building a new solution or improving an existing one, we deliver reliable, scalable, and user-friendly software.",
    whyChooseUs: {
      heading: "Why Choose Us for Administrative Services",
      points: [
        "✔️ Our team of experienced developers, designers, and engineers has a successful track record of delivering high-quality, scalable, and secure software solutions across a range of industries — from startups to enterprise-level organizations.",
        "✔️ We focus on delivering intuitive, engaging user experiences. By combining UX/UI best practices with real user feedback, we build apps that not only work flawlessly but also delight users.",
        "✔️ We follow agile methodologies to keep you in the loop throughout the development cycle. Our iterative approach ensures faster delivery, continuous improvement, and the flexibility to adapt to changing needs.",
        "✔️ From idea validation and prototyping to development, deployment, and post-launch support — we offer complete software development services so you don’t have to juggle multiple vendors.",
        "✔️ We build with modern tech stacks and scalable architectures, so your software is not only ready for today but prepared for tomorrow. Whether it’s AI, cloud-native, or cross-platform mobile, we stay ahead of the curve.",
        "✔️ Quality is non-negotiable. We use rigorous testing, code reviews, and performance optimization to ensure your application runs smoothly, securely, and efficiently.",
        "✔️ We don’t just build apps — we build relationships. Our clients trust us as their long-term technology partner because we’re responsive, dependable, and invested in their success.",
      ],
    },
    icon: "🗂️",
  },
};
